import React, { useState } from 'react';
import { IconButton, styled, Tooltip, Typography } from '@mui/material';
import { Done } from '@mui/icons-material';
import { toast } from 'react-toastify';
import Dialog from 'components/dialogs/Dialog';
import PackagesAutoComplete from 'components/autocomplete/PackagesAutoComplete';
import { buildAddedPackage } from 'helpers/budgetItems';
import { moneyFormat } from 'helpers/moneyFormat';
import { Package } from 'types/package';
import { useNewSurgerie } from '../hooks/useNewSurgerie';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: 10,
});

const AddPackageDialog: React.FC<{ onExited(): void }> = ({ onExited }) => {
  const { surgerie, handleChangePackages } = useNewSurgerie();
  const [selected, setSelected] = useState<Package | null>(null);

  function handleSave() {
    if (!selected) {
      toast.error('Selecione o pacote');
      return;
    }

    handleChangePackages([...surgerie.packages, buildAddedPackage(selected)]);
    onExited();
  }

  return (
    <Dialog
      onExited={onExited}
      title="Adicionar pacote"
      maxWidth="sm"
      ComponentActions={
        <Tooltip title="Adicionar">
          <IconButton size="small" color="inherit" onClick={handleSave}>
            <Done />
          </IconButton>
        </Tooltip>
      }
    >
      <Container>
        <PackagesAutoComplete
          label="Pacote"
          placeholder="Digite o nome do pacote"
          selected={selected}
          onSelect={setSelected}
        />

        {selected && (
          <Typography variant="body2" color="textSecondary">
            {selected.products?.length || 0} produtos inclusos. Entra com o valor máximo sugerido (
            {moneyFormat(selected.sale_price_max)}); depois você pode editar o valor no pacote.
          </Typography>
        )}
      </Container>
    </Dialog>
  );
};

export default AddPackageDialog;
